import type { OktaUser } from '@sportybot-web/auth/context';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export function useDataDog({
  authenticated,
  user,
}: {
  authenticated: boolean | undefined;
  user: OktaUser;
}) {
  const enabled = import.meta.env.PROD;

  useEffect(() => {
    if (!datadogRum.getInitConfiguration() && enabled) {
      const allowedURLPattern = /https:\/\/sporty-gateway/;

      datadogRum.init({
        allowedGraphQlUrls: [allowedURLPattern],
        allowedTracingUrls: [allowedURLPattern],
        applicationId: '85f91263-635f-4f5b-8c12-3b56da940fc9',
        clientToken: 'pub0a53a56e2a01e0fc627fec9e92d95114',
        defaultPrivacyLevel: 'mask-user-input',
        env: import.meta.env.VITE_DATADOG_ENV,
        service: 'sportybot-web',
        sessionReplaySampleRate: 100,
        sessionSampleRate: 100,
        site: 'us5.datadoghq.com',
        trackBfcacheViews: true,
        trackViewsManually: false,
        version: __APP_VERSION__,
      });
    }
  }, [enabled]);

  useEffect(() => {
    if (!datadogLogs.getInitConfiguration() && enabled) {
      datadogLogs.init({
        clientToken: 'pub0a53a56e2a01e0fc627fec9e92d95114',
        env: import.meta.env.VITE_DATADOG_ENV,
        forwardConsoleLogs: ['log', 'debug', 'info', 'warn', 'error'],
        forwardErrorsToLogs: true,
        service: 'sportybot-web',
        sessionSampleRate: 100,
        silentMultipleInit: true,
        site: 'us5.datadoghq.com',
        version: __APP_VERSION__,
      });
    }
  }, [enabled]);

  useEffect(() => {
    if (authenticated && enabled) {
      const { email, firstName, id, lastName } = user;
      const name = `${firstName} ${lastName}`;
      datadogRum.setUser({ email, id, name });
    }
  }, [authenticated, user, enabled]);
}
